var _excluded = ["children", "className", "component"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import Transition from 'react-transition-group/Transition';
import '../../css/shared/animated_height.css';
import mergeRefs from 'react-merge-refs';
import { jsx as ___EmotionJSX } from "@emotion/core";
var AnimatedHeight = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  var {
      children,
      className,
      component: Component = 'div'
    } = _ref,
    transitionProps = _objectWithoutProperties(_ref, _excluded);
  var setHeight = React.useCallback((node, height) => {
    node.style.height = height;
    window.getComputedStyle(node).height;
  }, []);
  var animatedRef = React.useRef();
  var onExitOrEnter = React.useCallback(node => {
    var _animatedRef$current;
    return setHeight(node, "".concat((_animatedRef$current = animatedRef.current) === null || _animatedRef$current === void 0 ? void 0 : _animatedRef$current.getBoundingClientRect().height, "px"));
  }, [setHeight]);
  var onEntered = React.useCallback(node => setHeight(node, 'auto'), [setHeight]);
  var onExiting = React.useCallback(node => setHeight(node, ''), [setHeight]);
  var endListener = React.useCallback((node, done) => {
    node.addEventListener('transitionend', done, false);
  }, []);
  return ___EmotionJSX(Transition, _extends({}, transitionProps, {
    addEndListener: endListener,
    onEnter: onExitOrEnter,
    onEntered: onEntered,
    onExit: onExitOrEnter,
    onExiting: onExiting
  }), state => {
    var containerClassName = classNames({
      'vn-animated-height__container': true,
      ["vn-animated-height__container--".concat(state)]: ['entering', 'entered', 'exiting'].includes(state)
    }, className);
    return ___EmotionJSX("div", {
      className: containerClassName
    }, ___EmotionJSX("div", {
      className: "vn-animated-height__wrapper",
      ref: mergeRefs([ref, animatedRef])
    }, ___EmotionJSX(Component, {
      className: "vn-animated-height__wrapper-inner"
    }, children)));
  });
});
AnimatedHeight.propTypes = {
  className: PropTypes.string,
  component: PropTypes.string,
  in: PropTypes.bool
};
export default AnimatedHeight;